import React from 'react';
import UserAvatar from './UserAvatar';

function pick(user, ...keys) {
  if (!user) return '';
  for (const k of keys) {
    const v = user[k];
    if (v != null && String(v).trim() !== '') return String(v).trim();
  }
  return '';
}

/**
 * Compact identity: avatar + name + @username + #id
 */
export default function UserChip({ userId, user, size = 32, className = '', onClick, title }) {
  const id = user?.user_id ?? user?.UserID ?? userId;
  const name = pick(user, 'name', 'Name');
  const username = pick(user, 'username', 'Username');
  const label = name || username || (id != null ? `#${id}` : '—');
  const clickable = typeof onClick === 'function' && id != null;
  const Tag = clickable ? 'button' : 'div';
  return (
    <Tag
      type={clickable ? 'button' : undefined}
      title={title}
      onClick={clickable ? () => onClick(Number(id)) : undefined}
      className={`flex items-center gap-2.5 min-w-0 ${
        clickable
          ? 'rounded-lg -ml-1 px-1 py-0.5 text-left hover:bg-white/5 focus:outline-none focus-visible:ring-1 focus-visible:ring-primary/50'
          : ''
      } ${className}`}
    >
      <UserAvatar user={user || { user_id: id }} size={size} />
      <div className="min-w-0">
        <p className={`text-sm font-semibold truncate ${clickable ? 'text-primary hover:underline' : 'text-dark-text'}`}>
          {label}
        </p>
        <p className="text-xs text-dark-text-secondary truncate">
          {username ? `@${username}` : ''}
          {username && id != null ? ' · ' : ''}
          {id != null ? `#${id}` : ''}
        </p>
      </div>
    </Tag>
  );
}
